import React, { useEffect, useState } from 'react';
import '../styles/ReportLoading.css';
import { Header, Footer } from '../components';
import PulcinellaDarkBG from '../assets/images/pulcinella-dark-bg.png';
import { checkOnAuthStateChanged } from '../functions';

function ReportLoading() {
    const [loggedIn, setLoggedIn] = useState(null);

    useEffect(() => {
        document.title = "Report Loading | Clozers";

        const fetchUserData = async() => {
            const user = await checkOnAuthStateChanged();
            if ( user.status === 200 ) {
                setLoggedIn(true);
            }
            else {
                setLoggedIn(false);
            }
        };

        fetchUserData();
    }, []);

    return (
        <div className="report-loading-outer-container">
            <Header 
                loggedIn={loggedIn}
            />
            <div className="report-loading-inner-container">
                <img
                    src={PulcinellaDarkBG}
                    className="report-loading-image"
                    alt="Pulcinella"
                />
                <div className="report-loading-text-container">
                    <h1 className="heading-large-bold colour-white text-align-center">
                        Report is on its way
                    </h1>
                    <span className="body-regular colour-white block-text text-align-center">
                        Good things come to those who wait, and better things come to those who trust me. 
                        Sit tight, <span className="text-italic">guaglio</span>, your report is in the works - we'll send you an email when it's ready.
                    </span>
                </div>
            </div>
            <Footer />
        </div>
    )
};

export default ReportLoading;